
export interface PrefixedShardingSetting {
    prefix: string;
    shards: number[];
}
